// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"5cfbdedb","453":"d3e03a2f","551":"5a3e44c5"}[chunkId] + ".chunk.js";
};